import { useFormik } from "formik";
import { useEffect } from "react";
import { useLocalStorageState } from "../hooks/localStorage";
import { ProjectID } from "./project";

export interface SummaryFormValues {
  project: ProjectID;
}

const initialFormValues: SummaryFormValues = {
  project: "groundWater",
};

function useSummaryStorageData() {
  return useLocalStorageState({ key: "summaryForm", value: initialFormValues });
}

export function useSummaryForm() {
  const [initialValues, handleUpdateForm] = useSummaryStorageData();

  const formik = useFormik({
    initialValues,
    onSubmit: (_) => {},
  });

  useEffect(() => {
    handleUpdateForm(formik.values);
  }, [formik.values, handleUpdateForm]);

  return formik;
}
